// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* face_emotion_detection Panel Styles */

.face_emotion_detection-panel {
    position: fixed;
    top: 0;
    right: 0;
    width: 450px;
    height: 100vh;
    background: #1c1c1c;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    transform: translateX(0);
    transition: transform 0.3s ease;
    color: #fff;
}

.face_emotion_detection-panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #333;
    background: #252525;
}

.face_emotion_detection-panel-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
}

.face_emotion_detection-panel-close {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #aaa;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background-color 0.2s ease;
}

.face_emotion_detection-panel-close:hover {
    background: #333;
    color: #fff;
}

.face_emotion_detection-panel-content {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
}

/* Controls */
.emotion-controls {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}

.detection-toggle {
    flex: 1;
    padding: 12px 20px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #333;
    color: #fff;
}

.detection-toggle:hover {
    background: #444;
}

.detection-toggle.active {
    background: #4CAF50;
    color: white;
}

.detection-toggle.active:hover {
    background: #45a049;
}

.clear-history {
    padding: 12px 20px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    background: #444;
    color: #fff;
    transition: all 0.3s ease;
}

.clear-history:hover:not(:disabled) {
    background: #555;
}

.clear-history:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Current Emotion Display */
.current-emotion {
    background: #252525;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
}

.current-emotion h3 {
    margin: 0 0 15px 0;
    font-size: 16px;
    color: #aaa;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.emotion-display {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 20px 0;
    background: #1c1c1c;
    border-radius: 8px;
    margin-bottom: 20px;
}

.emotion-icon {
    font-size: 64px;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}

.emotion-name {
    font-size: 24px;
    font-weight: 600;
    text-transform: capitalize;
}

/* Emotion Scores */
.emotion-scores {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 15px;
}

.emotion-score {
    display: flex;
    align-items: center;
    gap: 10px;
}

.emotion-label {
    min-width: 120px;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 5px;
}

.emotion-bar {
    flex: 1;
    height: 20px;
    background: #333;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
}

.emotion-bar-fill {
    height: 100%;
    transition: width 0.5s ease;
    border-radius: 10px;
}

.emotion-value {
    min-width: 45px;
    text-align: right;
    font-size: 13px;
    font-weight: 600;
    color: #aaa;
}

/* Emotion Details */
.emotion-details {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #333;
}

.emotion-details summary {
    cursor: pointer;
    font-size: 14px;
    color: #aaa;
    margin-bottom: 10px;
    outline: none;
}

.emotion-details summary:hover {
    color: #fff;
}

.emotion-params {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    font-size: 12px;
    color: #999;
    margin-top: 10px;
}

.emotion-params div {
    padding: 5px;
    background: #1c1c1c;
    border-radius: 4px;
}

/* Error State */
.face_emotion_detection-error {
    background: #ff5252;
    color: white;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
}

/* Detection Status */
.detection-status {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px;
    background: #1e7e34;
    color: white;
    border-radius: 8px;
    margin-bottom: 16px;
    font-size: 14px;
}

.status-indicator {
    width: 8px;
    height: 8px;
    background: #28a745;
    border-radius: 50%;
    animation: pulse-green 2s infinite;
}

@keyframes pulse-green {
    0% {
        box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
    }
    70% {
        box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
    }
}

/* Current Face Data */
.current-face-data {
    background: #252525;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
}

.current-face-data h3 {
    margin: 0 0 15px 0;
    font-size: 16px;
    color: #aaa;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.current-face-data h4 {
    margin: 15px 0 10px 0;
    font-size: 14px;
    color: #aaa;
    text-transform: uppercase;
    letter-spacing: 1px;
}

/* Face Parameters */
.face-parameters {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #333;
}

.face-parameters summary {
    cursor: pointer;
    font-size: 14px;
    color: #aaa;
    margin-bottom: 10px;
    outline: none;
}

.face-parameters summary:hover {
    color: #fff;
}

.parameter-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    font-size: 12px;
    color: #999;
    margin-top: 10px;
}

.parameter-grid div {
    padding: 5px;
    background: #1c1c1c;
    border-radius: 4px;
}

/* No Face Detected */
.no-face-detected {
    text-align: center;
    padding: 40px 20px;
    color: #666;
    background: #252525;
    border-radius: 12px;
    border: 2px dashed #333;
}

.no-face-detected p {
    margin: 8px 0;
}

.no-face-detected p:first-child {
    font-size: 16px;
    color: #999;
}

@media (max-width: 480px) {
    .parameter-grid {
        grid-template-columns: 1fr;
    }
}

/* Loading State */
.face_emotion_detection-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    text-align: center;
}

.loading-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #333;
    border-top: 3px solid #4CAF50;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* Scrollbar Styling */
.face_emotion_detection-panel-content::-webkit-scrollbar {
    width: 8px;
}

.face_emotion_detection-panel-content::-webkit-scrollbar-track {
    background: #1c1c1c;
}

.face_emotion_detection-panel-content::-webkit-scrollbar-thumb {
    background: #444;
    border-radius: 4px;
}

.face_emotion_detection-panel-content::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* Responsive Design */
@media (max-width: 768px) {
    .face_emotion_detection-panel {
        width: 100%;
        height: 100vh;
    }
    
    .emotion-display {
        flex-direction: column;
    }
    
    .emotion-params {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 480px) {
    .face_emotion_detection-panel-header {
        padding: 12px 16px;
    }
    
    .face_emotion_detection-panel-title {
        font-size: 16px;
    }
    
    .face_emotion_detection-panel-content {
        padding: 16px;
    }
    
    .emotion-icon {
        font-size: 48px;
    }
    
    .emotion-name {
        font-size: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./react/features/face_emotion_detection/components/web/face_emotion_detection-panel.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA,aAAa;AACb;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,0CAA0C;IAC9C;IACA;QACI,2CAA2C;IAC/C;IACA;QACI,wCAAwC;IAC5C;AACJ;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA,sBAAsB;AACtB;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* face_emotion_detection Panel Styles */\n\n.face_emotion_detection-panel {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 450px;\n    height: 100vh;\n    background: #1c1c1c;\n    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);\n    z-index: 1000;\n    display: flex;\n    flex-direction: column;\n    transform: translateX(0);\n    transition: transform 0.3s ease;\n    color: #fff;\n}\n\n.face_emotion_detection-panel-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 20px;\n    border-bottom: 1px solid #333;\n    background: #252525;\n}\n\n.face_emotion_detection-panel-title {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #fff;\n}\n\n.face_emotion_detection-panel-close {\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    color: #aaa;\n    padding: 4px 8px;\n    border-radius: 4px;\n    transition: background-color 0.2s ease;\n}\n\n.face_emotion_detection-panel-close:hover {\n    background: #333;\n    color: #fff;\n}\n\n.face_emotion_detection-panel-content {\n    flex: 1;\n    overflow-y: auto;\n    padding: 20px;\n}\n\n/* Controls */\n.emotion-controls {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n.detection-toggle {\n    flex: 1;\n    padding: 12px 20px;\n    border: none;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    background: #333;\n    color: #fff;\n}\n\n.detection-toggle:hover {\n    background: #444;\n}\n\n.detection-toggle.active {\n    background: #4CAF50;\n    color: white;\n}\n\n.detection-toggle.active:hover {\n    background: #45a049;\n}\n\n.clear-history {\n    padding: 12px 20px;\n    border: none;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    background: #444;\n    color: #fff;\n    transition: all 0.3s ease;\n}\n\n.clear-history:hover:not(:disabled) {\n    background: #555;\n}\n\n.clear-history:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Current Emotion Display */\n.current-emotion {\n    background: #252525;\n    border-radius: 12px;\n    padding: 20px;\n    margin-bottom: 20px;\n}\n\n.current-emotion h3 {\n    margin: 0 0 15px 0;\n    font-size: 16px;\n    color: #aaa;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.emotion-display {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    padding: 20px 0;\n    background: #1c1c1c;\n    border-radius: 8px;\n    margin-bottom: 20px;\n}\n\n.emotion-icon {\n    font-size: 64px;\n    animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n    0% {\n        transform: scale(1);\n    }\n    50% {\n        transform: scale(1.1);\n    }\n    100% {\n        transform: scale(1);\n    }\n}\n\n.emotion-name {\n    font-size: 24px;\n    font-weight: 600;\n    text-transform: capitalize;\n}\n\n/* Emotion Scores */\n.emotion-scores {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 15px;\n}\n\n.emotion-score {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.emotion-label {\n    min-width: 120px;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.emotion-bar {\n    flex: 1;\n    height: 20px;\n    background: #333;\n    border-radius: 10px;\n    overflow: hidden;\n    position: relative;\n}\n\n.emotion-bar-fill {\n    height: 100%;\n    transition: width 0.5s ease;\n    border-radius: 10px;\n}\n\n.emotion-value {\n    min-width: 45px;\n    text-align: right;\n    font-size: 13px;\n    font-weight: 600;\n    color: #aaa;\n}\n\n/* Emotion Details */\n.emotion-details {\n    margin-top: 15px;\n    padding-top: 15px;\n    border-top: 1px solid #333;\n}\n\n.emotion-details summary {\n    cursor: pointer;\n    font-size: 14px;\n    color: #aaa;\n    margin-bottom: 10px;\n    outline: none;\n}\n\n.emotion-details summary:hover {\n    color: #fff;\n}\n\n.emotion-params {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n    font-size: 12px;\n    color: #999;\n    margin-top: 10px;\n}\n\n.emotion-params div {\n    padding: 5px;\n    background: #1c1c1c;\n    border-radius: 4px;\n}\n\n/* Error State */\n.face_emotion_detection-error {\n    background: #ff5252;\n    color: white;\n    padding: 12px 16px;\n    border-radius: 8px;\n    margin-bottom: 16px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n/* Detection Status */\n.detection-status {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px;\n    background: #1e7e34;\n    color: white;\n    border-radius: 8px;\n    margin-bottom: 16px;\n    font-size: 14px;\n}\n\n.status-indicator {\n    width: 8px;\n    height: 8px;\n    background: #28a745;\n    border-radius: 50%;\n    animation: pulse-green 2s infinite;\n}\n\n@keyframes pulse-green {\n    0% {\n        box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);\n    }\n    70% {\n        box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);\n    }\n    100% {\n        box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);\n    }\n}\n\n/* Current Face Data */\n.current-face-data {\n    background: #252525;\n    border-radius: 12px;\n    padding: 20px;\n    margin-bottom: 20px;\n}\n\n.current-face-data h3 {\n    margin: 0 0 15px 0;\n    font-size: 16px;\n    color: #aaa;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.current-face-data h4 {\n    margin: 15px 0 10px 0;\n    font-size: 14px;\n    color: #aaa;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n/* Face Parameters */\n.face-parameters {\n    margin-top: 15px;\n    padding-top: 15px;\n    border-top: 1px solid #333;\n}\n\n.face-parameters summary {\n    cursor: pointer;\n    font-size: 14px;\n    color: #aaa;\n    margin-bottom: 10px;\n    outline: none;\n}\n\n.face-parameters summary:hover {\n    color: #fff;\n}\n\n.parameter-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n    font-size: 12px;\n    color: #999;\n    margin-top: 10px;\n}\n\n.parameter-grid div {\n    padding: 5px;\n    background: #1c1c1c;\n    border-radius: 4px;\n}\n\n/* No Face Detected */\n.no-face-detected {\n    text-align: center;\n    padding: 40px 20px;\n    color: #666;\n    background: #252525;\n    border-radius: 12px;\n    border: 2px dashed #333;\n}\n\n.no-face-detected p {\n    margin: 8px 0;\n}\n\n.no-face-detected p:first-child {\n    font-size: 16px;\n    color: #999;\n}\n\n@media (max-width: 480px) {\n    .parameter-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* Loading State */\n.face_emotion_detection-loading {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 40px;\n    text-align: center;\n}\n\n.loading-spinner {\n    width: 32px;\n    height: 32px;\n    border: 3px solid #333;\n    border-top: 3px solid #4CAF50;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-bottom: 16px;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n/* Scrollbar Styling */\n.face_emotion_detection-panel-content::-webkit-scrollbar {\n    width: 8px;\n}\n\n.face_emotion_detection-panel-content::-webkit-scrollbar-track {\n    background: #1c1c1c;\n}\n\n.face_emotion_detection-panel-content::-webkit-scrollbar-thumb {\n    background: #444;\n    border-radius: 4px;\n}\n\n.face_emotion_detection-panel-content::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .face_emotion_detection-panel {\n        width: 100%;\n        height: 100vh;\n    }\n    \n    .emotion-display {\n        flex-direction: column;\n    }\n    \n    .emotion-params {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 480px) {\n    .face_emotion_detection-panel-header {\n        padding: 12px 16px;\n    }\n    \n    .face_emotion_detection-panel-title {\n        font-size: 16px;\n    }\n    \n    .face_emotion_detection-panel-content {\n        padding: 16px;\n    }\n    \n    .emotion-icon {\n        font-size: 48px;\n    }\n    \n    .emotion-name {\n        font-size: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
